/* Worry-Free Shipping cart add-on — In The Barn (Dawn). Theme path: assets/worry-free.js
 * Port of HollerBorn's assets/worry-free.js (opt-in, HB live 2026-10-17). Replaces the Captain Protection (ShipWill) app.
 *
 * Loaded from layout/theme.liquid, NOT from the snippet: Dawn swaps the cart drawer's HTML in after page load
 * (innerHTML replacement), and a <script> inside injected HTML never executes. A document-level delegated listener
 * loaded once in the layout survives every re-render.
 *
 * Behaviour (same as HB):
 *   - click the box  → set variant 67786604708132 ($1.50) to quantity 1 or 0 via /cart/update.js
 *                      (ABSOLUTE by variant: never increments, adds the line if missing, never uses line numbers).
 *                      /cart/add.js increments (tick→untick→tick left quantity 2) and /cart/change.js 400s when the
 *                      line does not exist yet, so update.js is the only endpoint that does both halves safely.
 *   - OPT-IN: the box starts EMPTY and nothing is ever added automatically (Google answer/9158778; a pre-ticked box
 *     is not consent in the UK). Ticking sets localStorage wf_optin=1; unticking clears it.
 *   - cleanup, once per page view: if our line is in the cart but THIS browser never ticked it, it is removed.
 * ITB additions (not in HB):
 *   - the same cleanup also removes the retired Captain app lines (products 10138777780516 / 10138773324068),
 *     listed by the snippet in data-wf-legacy;
 *   - an "orphan" line (ours left alone after the last product was removed — the row is hidden then) is removed;
 *   - cleanup never reloads on failure (no reload loop); only a click falls back to a reload, like HB.
 *
 * Re-render: Dawn's own pattern (assets/cart.js, cart-drawer.js) — ask /cart/update.js for the sections this page
 * has, then replace innerHTML:  cart-drawer → #CartDrawer .drawer__inner · cart-icon-bubble → #cart-icon-bubble ·
 * <main-cart-items id> → #main-cart-items .js-contents · <main-cart-footer id> → #main-cart-footer .js-contents
 * (max 5 sections per request; this asks for at most 4).
 */
(function () {
  if (window.__wfInit) return;
  window.__wfInit = true;

  var VARIANT = 67786604708132;
  var OPT_IN = 'wf_optin';
  var cleanTried = false;
  var busy = false;

  function optedIn() {
    try { return window.localStorage.getItem(OPT_IN) === '1'; } catch (e) { return false; }
  }
  function setOptIn(on) {
    try { on ? window.localStorage.setItem(OPT_IN, '1') : window.localStorage.removeItem(OPT_IN); } catch (e) {}
  }
  function updateUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/update.js';
  }
  function legacyIds(row) {
    return (row.getAttribute('data-wf-legacy') || '').split(',').filter(Boolean);
  }

  // The Dawn sections present on THIS page, and where each one's fresh HTML goes.
  function targets() {
    var list = [];
    var drawer = document.querySelector('#CartDrawer .drawer__inner');
    if (drawer) list.push({ section: 'cart-drawer', el: drawer, selector: '.drawer__inner' });
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) list.push({ section: 'cart-icon-bubble', el: bubble, selector: '.shopify-section' });
    var items = document.getElementById('main-cart-items');
    if (items && items.dataset.id) {
      list.push({ section: items.dataset.id, el: items.querySelector('.js-contents'), selector: '.js-contents' });
    }
    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) {
      list.push({ section: footer.dataset.id, el: footer.querySelector('.js-contents'), selector: '.js-contents' });
    }
    return list.filter(function (t) { return !!t.el; });
  }

  function render(state, list) {
    if (!state || !state.sections) return false;
    var ok = true;
    list.forEach(function (t) {
      var html = state.sections[t.section];
      var src = html ? new DOMParser().parseFromString(html, 'text/html').querySelector(t.selector) : null;
      if (!src) { ok = false; return; }
      t.el.innerHTML = src.innerHTML;
    });
    // Dawn toggles these itself after /cart/change.js; mirror it so an emptied cart shows the empty state.
    var empty = state.item_count === 0;
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) drawerEl.classList.toggle('is-empty', empty);
    var cartItems = document.querySelector('cart-items');
    if (cartItems) cartItems.classList.toggle('is-empty', empty);
    var footerEl = document.getElementById('main-cart-footer');
    if (footerEl) footerEl.classList.toggle('is-empty', empty);
    return ok;
  }

  function update(updates) {
    var list = targets();
    var body = { updates: updates };
    if (list.length) {
      body.sections = list.map(function (t) { return t.section; });
      body.sections_url = window.location.pathname;
    }
    return fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/update.js ' + r.status);
        return r.json();
      })
      .then(function (state) {
        if (!render(state, list)) throw new Error('section render');
        // The free-ship bar repaints on DOM swaps already; this is belt and braces for anything else listening.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return state;
      });
  }

  function done() {
    busy = false;
    setTimeout(cleanUp, 0);   // catch an orphan our own re-render produced
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wf-toggle]');
    if (!btn) return;
    var row = btn.closest('[data-wf]');
    if (!row) return;
    e.preventDefault();                 // never let the fallback form navigate
    e.stopPropagation();
    if (btn.disabled || busy) return;
    btn.disabled = true;
    busy = true;
    var on = row.getAttribute('data-wf-on') === 'true';
    setOptIn(!on);                      // ticking = opt in; unticking = opt out
    var updates = {};
    updates[VARIANT] = on ? 0 : 1;
    legacyIds(row).forEach(function (id) { updates[id] = 0; });   // drop any old Captain line in the same call
    var inDrawer = !!btn.closest('cart-drawer');
    update(updates)
      .then(function () {
        var scope = inDrawer ? document.querySelector('cart-drawer') : document.getElementById('main-cart-footer');
        var again = scope && scope.querySelector('[data-wf-toggle]');
        if (again) again.focus();
        done();
      })
      .catch(function () { window.location.reload(); });
  });

  // Opt-in only. Never adds anything.
  function cleanUp() {
    if (busy) return;
    var row = document.querySelector('[data-wf]');
    if (!row) return;
    var updates = {};
    var need = false;

    // Once per page view: retired Captain lines, and our line where this browser never ticked it.
    if (!cleanTried) {
      legacyIds(row).forEach(function (id) { updates[id] = 0; need = true; });
      if (row.getAttribute('data-wf-on') === 'true' && !optedIn()) { updates[VARIANT] = 0; need = true; }
      if (need) cleanTried = true;
    }
    // Once per rendered marker: our line (or a Captain line) left alone after the last product went.
    if (row.getAttribute('data-wf-orphan') === 'true' && !row.__wfOrphanDone) {
      row.__wfOrphanDone = true;
      if (row.getAttribute('data-wf-on') === 'true') { updates[VARIANT] = 0; need = true; }
      legacyIds(row).forEach(function (id) { updates[id] = 0; need = true; });
    }
    if (!need) return;

    busy = true;
    update(updates).then(done, function () { busy = false; });   // best effort: no reload, no loop
  }

  if (document.readyState !== 'loading') cleanUp();
  document.addEventListener('DOMContentLoaded', cleanUp);
  new MutationObserver(cleanUp).observe(document.documentElement, { childList: true, subtree: true });
})();
